import { render, staticRenderFns } from "./ZoneConIndividualAwardEdit.vue?vue&type=template&id=1461ea46"
import script from "./ZoneConIndividualAwardEdit.vue?vue&type=script&lang=js"
export * from "./ZoneConIndividualAwardEdit.vue?vue&type=script&lang=js"
import style0 from "./ZoneConIndividualAwardEdit.vue?vue&type=style&index=0&id=1461ea46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports